import { useEffect } from 'react';

// 모달 오픈 횟수를 추적하는 전역 변수
let lockCount = 0;

/**
 * 모달 오픈 시 배경 스크롤 방지 훅 (Reference Counting 적용)
 * @param {boolean} isOpen - 모달 오픈 여부
 */
const useScrollLock = (isOpen) => {
    useEffect(() => {
        if (isOpen) {
            lockCount++;
            // 첫 번째 모달이 열릴 때만 스타일 적용
            if (lockCount === 1) {
                document.body.style.setProperty('overflow', 'hidden', 'important');
                document.documentElement.style.setProperty('overflow', 'hidden', 'important');
                document.body.style.overscrollBehavior = 'none';
            }
        }

        return () => {
            if (isOpen) {
                lockCount--;
                // 마지막 모달이 닫힐 때만 스타일 제거
                if (lockCount === 0) {
                    document.body.style.removeProperty('overflow');
                    document.documentElement.style.removeProperty('overflow');
                    document.body.style.overscrollBehavior = '';
                }
            }
        };
    }, [isOpen]);
};

export default useScrollLock;
